import * as React from 'react';
import { useState, useEffect } from 'react';
import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import { InfoType } from '../pages/Dashboard';

dayjs.extend(timezone);
dayjs.extend(utc);

interface Props {
  infos: InfoType[] | undefined;
}
function Information(props: Props) {
  useEffect(() => {
    setInfos(props.infos);
  }, [props.infos]);
  const [infos, setInfos] = useState(props.infos);
  return (
    <Stack spacing={1} overflow='auto'>
      {infos?.map((info, idx) => (
        <div key={idx}>
          <Typography color='blue'>{info.startDate}</Typography>
          <div
            dangerouslySetInnerHTML={{
              __html: info.information,
            }}
          />
        </div>
      ))}
    </Stack>
  );
}

export default Information;
